export default __webpack_public_path__ + "static/media/strategy4.d4ed7a34.png";